export default "__VITE_ASSET__bbd268f3__"